<template>
  <div>
    <div class="module_addi">
      <div class="p">
        是否在生产经营、持续发展中面临的各类实际困难和需求？<br/>
        关于园区转型、产业发展、投资环境等方面的意见和建议有自己的看法？<br/>
        提出您的诉求，由我们协助帮忙解决！
      </div>
      <div class="btn_outer">
        <el-button type="primary" plain @click="dialogVisible = true"><i class="cloudicon ci_modify"></i> 我有诉求
        </el-button>
      </div>
    </div>
    <div class="user_module">
      <div class="module_head">
        <div>
          您的诉求记录
        </div>
        <div>
          <!--<img :src="imgUrl+'icon_more.png'"/>-->
        </div>
      </div>
      <div class="module_list_outer">
        <div class="module_list" v-for="(item,index) in xmData" @click="detailSQ(item.id)">
          <div class="cl" style="width: 30%;">
            <div class="xm xm_name cl_col1">
              {{ item.sq_title }}
            </div>
          </div>
          <div class="cl" style="width: 15%;">
            <div class="q q9">
              诉求状态
            </div>
            <div class="stc" :class="{statsubm:item.statusname==statsubm,stathand:stathand.indexOf(item.statusname)>-1}" style="font-size: 14px;">
              {{ item.statusname }}
            </div>
          </div>
          <div class="cl" style="width: 15%;">
            <div class="q q9">
              处理单位
            </div>
            <div style="font-size: 14px;">
              {{ item.opt_dep }}
            </div>
          </div>

          <div class="cl" style="width: 20%;">
            <div class="q q9">
              提问时间
            </div>
            <div class="fs lh">
              {{ item.refer_time }}
            </div>
          </div>
          <div class="cl" style="width: 20%;">
            <div class="q q9">
              处理时间
            </div>
            <div class="fs lh">
              {{ item.opt_time }}
            </div>
          </div>
        </div>
      </div>
      <el-pagination
        background
        layout="prev, pager, next,jumper"
        :current-page="currentPage"
        :page-size="pagesize"
        :total="total"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>

    <el-dialog
      title="提交诉求"
      :visible.sync="dialogVisible"
      width="840px">

		  <addappeal @emitClose="close" ></addappeal>
    </el-dialog>

    <el-dialog
      title="诉求记录   "
      :visible.sync="dialogVisibleView"
      width="500px">
      <div class="dialog_head2">
        <div class="tit" v-text="currentItem.question.sq_title"></div>
        <div class="info"><span class="span" v-text="'提问时间：'+ currentItem.question.refer_time"></span> <span class="span" v-text="'诉求类型：'+currentItem.question.sq_cate_name"></span></div>
        <div class="ques" v-text="currentItem.question.sq_content">
        </div>
      </div>

      <div class="dialog_main">
        <div class="step_outer" v-for="(item,index) in currentItem.reply">
          <div class="step_cont">
            <div class="row1">第{{ index+1 }}次回复</div>
            <div class="row2">{{ item.opt_ret }}</div>
            <div class="row3">处理时间：{{ item.opt_time }}</div>
          </div>
          <img v-if="index==0" class="img" :src="imgUrl+'step_circle.png'"/>
          <img v-if="index!=0" class="img" :src="imgUrl+'step_circle2.png'"/>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {

  created() {
    this.getAppealList02();
  },
  name: 'userappeal',
  inject:['reload'],
  data() {
    return {
      total:0,
      currentPage: 1,
      pagesize: 10,
      currentItem:{
        question:{},
        reply:[]
      },
      xmData: [
      ],
      statsubm: '已提交',
      stathand: '已处理',
      dialogVisible: false,
      dialogVisibleView: false,
      /*appealCont: '',
      appealTit: '',
      appealCate: '',
      options: [{
        value: '1',
        label: '政策申报类'
      }, {
        value: '2',
        label: '人员招聘'
      }, {
        value: '3',
        label: '人才服务类'
      }, {
        value: '4',
        label: '融资需求类'
      }, {
        value: '5',
        label: '项目建设类'
      },{
        value: '5',
        label: '项目建设类'
      },{
        value: '6',
        label: '基础设施建设类'
      },{
        value: '7',
        label: '安全及环保类'
      },{
        value: '8',
        label: '厂房土地类需求'
      },{
        value: '9',
        label: '其他'
      }
      ],*/
      replyArr: [
        {cont: '生产情况一季度下降15%，全年暂时无法估计。', time: '2019-07-10 09:51:37'},
        {cont: '生产情况一季度下降15%，全年暂时无法估计。', time: '2019-07-10 09:51:37'},
        {cont: '生产情况一季度下降15%，全年暂时无法估计。', time: '2019-07-10 09:51:37'},
        {cont: '生产情况一季度下降15%，全年暂时无法估计。', time: '2019-07-10 09:51:37'},
      ]
    }
  },
  methods: {
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getAppealList02();
    },
    indChange() {

    },
    close(){
    	this.dialogVisible=false;
    	this.reload()
    },
    async getAppealList02() {
      let res = await this.$ajax.get(this.bUrl + 'api/portal/questions/index?page=' + this.currentPage+'&pagesize=10');
      this.xmData = res.data.data.list;
      this.total = res.data.data.total;
      if(res.data.code!=200){
        this.$message.error(res.data.msg);
      }
    },
/*    async  submitSQ(){
      let data={
        sq_cate:this.appealCate,
        sq_title:this.appealTit,
        sq_content:this.appealCont
      }
      let res = await this.$ajax.post(this.bUrl + 'api/portal/questions/add',data);
      this.dialogVisible=false;
      this.$message.success(res.data.msg);
    },*/
    async  detailSQ(id){
      let res = await this.$ajax.get(this.bUrl + 'api/portal/questions/detail?id='+id);
      this.currentItem=res.data.data;
      this.dialogVisibleView=true;
      if(res.data.code!=200){
        this.$message.error(res.data.msg);
      }
    }
  }
}
</script>

<style scoped>
.user_module {
  width: 100%;
  box-sizing: border-box;
  padding: 25px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 3px 16px rgba(196, 196, 196, .16);
  border: 1px solid #E1EAFA;
  margin-bottom: 20px;
}

.module_tab_cont {
  margin-top: 25px;
}

.module_addi {
  width: 100%;
  margin: 10px 0 30px 0;
  display: flex;
  justify-content: space-between;
}

.module_addi .p {
  color: #6F88AF;
}

.ci_modify {
  font-size: 24px;
}

.module_head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 14px;
  font-size: 18px;
  color: #143367;
}

.module_list .xm_name {
  width: 200px;
}

.module_list .stc {
  /*color: #72A757;*/
}

.module_list .statsubm {
  color: #0093FF;
}

.module_list .stathand {
  color: #72A757;
}

.module_list .cl {
  margin-right: 24px;
}

.dialog_head2 {
  padding: 10px 0;
  border-bottom: 1px solid #E2E1E2;
  border-top: 1px solid #E2E1E2;
}

.dialog_head2 .tit {
  font-size: 22px;
  letter-spacing: 2px;
  margin-bottom: 10px;
  color: #000;
}

.dialog_head2 .info {
  color: rgba(102, 102, 102, .6);
  margin-bottom: 10px;
}

.dialog_head2 .info .span {
  margin-right: 40px;
}

.dialog_head2 .ques {
  line-height: 28px;
}

.dialog_main .step_outer {
  position: relative;
  padding: 20px 20px 0 20px;
  border-left: 3px solid rgba(102, 102, 102, .2);
}

.step_outer img {
  position: absolute;
  left: -9px;
  top: 38px;
}

.dialog_main .step_outer:last-child {
  padding-bottom: 20px;
}

.step_outer .step_cont {
  position: relative;
  border: 1px solid #E2E1E2;
  padding: 15px;
  border-radius: 10px;
}

.step_outer .step_cont .row1 {
  color: #000;
  font-weight: bold;
  margin-bottom: 10px;
}

.step_outer .step_cont .row3 {
  color: rgba(102, 102, 102, .6);
  margin-top: 8px;
  font-size: 13px;
}

.step_cont:before {
  content: '';
  display: inline-block;
  width: 8px;
  height: 8px;
  background: #fff;
  border: 1px solid #E2E1E2;
  border-right: transparent;
  border-bottom: transparent;
  position: absolute;
  left: -5px;
  top: 20px;
  transform: rotate(-45deg);
}
</style>



// WEBPACK FOOTER //
// src/components/user/userappeal.vue